import React, { useEffect } from "react";
import "./style.less";
import {
  useParams,
  Switch,
  Route,
  useRouteMatch,
  Link
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentCityName } from "../../../redux/geofence/actions";
import FenceFilter from "./FenceFilter";
import CreateGeofence from "./CreateGeofence";
import UpdateGeofence from "./UpdateGeofence";
import { Button } from "semantic-ui-react";

function CityView() {
  const match = useRouteMatch();
  const { cityName } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentCityName(cityName));
  }, [cityName, dispatch]);

  return (
    <div className="CityView">
      <Switch>
        <Route exact path={match.url}>
          <FenceFilter />
        </Route>
        <Route exact path={`${match.url}/add`}>
          <CreateGeofence />
        </Route>
        <Route exact path={`${match.url}/update`}>
          <UpdateGeofence />
        </Route>
        <Route exact path={`${match.url}/add/success`}>
          <div className="CreateGeofence">
            <h2>Geofence Created</h2>
            <Link to={`${match.url}/add`}>
              <Button fluid primary>
                Create another Geofence
              </Button>
            </Link>
            <br />
            <Link to={`${match.url}/`}>
              <Button fluid inverted primary>
                Go to main city view
              </Button>
            </Link>
          </div>
        </Route>
        <Route exact path={`${match.url}/update/success`}>
          <div className="UpdateGeofence">
            <h2>Geofence Updated</h2>
            <Link to={`${match.url}/`}>
              <Button fluid primary>
                Go to main city view
              </Button>
            </Link>
          </div>
        </Route>
      </Switch>
    </div>
  );
}

CityView.defaultProps = {};

CityView.propTypes = {};

export default CityView;
